import React from 'react';

interface IProps {
  fillColor: string;
  className: string;
}

const defaultProps = {
  className: '',
  fillColor: '#53585E',
};

const AnchorAppIcon = ({
  fillColor,
  className,
}: IProps): React.ReactElement<React.ReactNode> => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 77 77"
    className={className}
  >
    <defs>
      <filter
        id="a"
        width="140.3%"
        height="140.3%"
        x="-20.1%"
        y="-20.1%"
        filterUnits="objectBoundingBox"
      >
        <feOffset
          dy="2"
          in="SourceAlpha"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation="2.5"
        ></feGaussianBlur>
        <feColorMatrix
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
          values="0 0 0 0 0.160784314 0 0 0 0 0.184313725 0 0 0 0 0.211764706 0 0 0 0.1 0"
        ></feColorMatrix>
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
          <feMergeNode in="SourceGraphic"></feMergeNode>
        </feMerge>
      </filter>
      <linearGradient id="b" x1="50%" x2="50%" y1="-4.737%" y2="137.63%">
        <stop offset="0%" stopColor="#AE4EFF"></stop>
        <stop offset="44.522%" stopColor="#8940FA"></stop>
        <stop offset="65.974%" stopColor="#893FFA"></stop>
        <stop offset="100%" stopColor="#8E47FA"></stop>
      </linearGradient>
    </defs>
    <g
      fill="none"
      fillRule="evenodd"
      stroke="none"
      strokeWidth="1"
      filter="url(#a)"
      transform="translate(-145 -197) translate(150 200)"
    >
      <rect
        width="66.744"
        height="66.744"
        x="0"
        y="0"
        fill="url(#b)"
        rx="16"
      ></rect>
      <path
        fill="#FFF"
        stroke="#FFF"
        strokeWidth="0.5"
        d="M39.75 11.016c7.426 3.997 12.605 12.482 12.78 22.356-.175 9.874-5.354 18.359-12.78 22.356h0l-2.166-3.584c5.727-3.066 9.843-9.298 10.6-16.695h0l.058-2.077-.059-2.077c-.757-7.397-4.872-13.63-10.599-16.695h0zm-3.994 5.832l.508.28c2.596 1.433 4.804 3.661 6.384 6.443 1.614 2.841 2.498 6.143 2.556 9.55v.02c-.058 3.405-.942 6.707-2.556 9.549-1.58 2.782-3.788 5.01-6.384 6.443l-.508.28-2.06-3.497.529-.29c1.83-1.005 3.43-2.546 4.625-4.455 1.22-1.949 1.992-4.244 2.234-6.638l.039-1.403-.04-1.402c-.241-2.395-1.013-4.69-2.233-6.638-1.196-1.91-2.795-3.45-4.625-4.455l-.529-.29 2.06-3.497zm-3.264 6.48l1.07.591c1.528.843 2.822 2.146 3.744 3.77.931 1.638 1.44 3.54 1.474 5.497v.042c-.033 1.958-.543 3.86-1.474 5.499-.922 1.623-2.216 2.926-3.743 3.769l-1.07.59-2.037-3.455 1.117-.612c1.42-.78 2.491-2.262 2.95-4.013H21.17a3.653 3.653 0 01-3.27 2.013c-2.009 0-3.644-1.617-3.644-3.606 0-1.988 1.635-3.605 3.645-3.605 1.404 0 2.625.79 3.234 1.944h13.47c-.403-1.9-1.52-3.526-3.032-4.356l-1.117-.613 2.036-3.455zM17.927 32.4c-.595 0-1.079.48-1.079 1.067 0 .59.484 1.068 1.079 1.068s1.079-.479 1.079-1.068c0-.588-.484-1.067-1.08-1.067z"
      ></path>
    </g>
  </svg>
);

AnchorAppIcon.defaultProps = defaultProps;

export { AnchorAppIcon };
